import { useEffect, useState } from 'react'

import { useRemoteStrings } from '@acorns/web-utils'

import { checkIsGoogleChrome } from 'utils/browser/detection'
import { Platform, getPlatform } from 'utils/device/detection'

export const useDisplayChromeExtensionCard = () => {
  const { getRemoteString, isLoadingRemoteStrings } = useRemoteStrings()
  const [showCard, setShowCard] = useState(false)
  const [loading, setLoading] = useState(true)

  const isDesktop = getPlatform() === Platform.Desktop
  const isGoogleChrome = checkIsGoogleChrome()

  const trackingImageLink = getRemoteString({
    key: 'earn.extension.tracking_asset.chrome',
  })

  useEffect(() => {
    if (isLoadingRemoteStrings) {
      return
    }

    if (!isDesktop || !isGoogleChrome) {
      setLoading(false)

      return
    }

    const checkActiveEarnExtension = async () => {
      try {
        await fetch(trackingImageLink)

        setShowCard(false)
        setLoading(false)
      } catch (err) {
        setShowCard(true)
        setLoading(false)
      }
    }

    checkActiveEarnExtension()
  }, [isDesktop, isGoogleChrome, isLoadingRemoteStrings, trackingImageLink])

  return {
    showChromeCard: showCard,
    loading,
  }
}
